<div class="container-fluid px-0">
    <div class="row">
        <div class="col-md-4">
            <div class="card shadow-none">
                <div class="card-body pb-0">
                    <div class="row pt-2 pb-2">
                        <div class="col-md-auto">
                            <label class="text-lg"
                                >Danh sách đã phê duyệt</label
                            >
                        </div>

                        <div class="input-group mt-3">
                            <form
                                [formGroup]="searchForm"
                                class="input-group"
                                (ngSubmit)="
                                    searchData(searchForm.value.searchInput)
                                "
                            >
                                <div class="input-group-prepend">
                                    <button
                                        class="btn btn-primary d-inline-flex pr-2 pl-2"
                                        type="submit"
                                    >
                                        <span class="material-icons"
                                            >search</span
                                        >
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="searchInput"
                                    id="searchInput"
                                    placeholder="Nhập tài khoản cá nhân..."
                                    aria-label=""
                                    aria-describedby="basic-addon1"
                                />
                            </form>
                        </div>
                    </div>
                </div>

                <div class="position-relative">
                    <app-mini-spinner
                        *ngIf="loadingListUserGroupIsVisiable() | async"
                    ></app-mini-spinner>
                    <ng-template #noData>
                        <div class="no-content-list">
                            <img
                                class="mb-2"
                                src="assets/img/icon/icon-no-user-group.png"
                                width="100"
                            />
                            <p class="mb-1">
                                Không có dữ liệu.
                            </p>
                        </div>
                    </ng-template>

                    <div>
                        <div
                            class="user-group-item content-list-item px-0 pt-2"
                        >
                            <div
                                *ngIf="listUserGroup.length > 0; else noData"
                                class="content-list fade show"
                            >
                                <div
                                    *ngFor="let item of listUserGroup"
                                    (click)="selectUserGroup(item)"
                                    class="user-group-item content-list-item px-4 pt-2"
                                    [class.active]="
                                        item.userId === detailUser.userId
                                    "
                                >
                                    <div class="border-bottom d-flex">
                                        <span
                                            class="material-icons icon-item pr-3"
                                            >group</span
                                        >
                                        <div class="flex-grow-1">
                                            <label class="title-item">{{
                                                item.ten !== '' ? item.ten : item.email
                                            }}</label>
                                            <p class="text-secondary">
                                                Số giấy tờ: {{ item.cmnd }}
                                            </p>
                                        </div>
                                        <!-- (click)="actBtnDelete($event, item.uuidRole)" -->
                                        <!-- <a -->
                                        <!--     class="text-decoration-underline text-primary pl-4" -->
                                        <!--     style="cursor: pointer;" -->
                                        <!--     >Gọi video</a -->
                                        <!-- > -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="totalElement > maxSize"
                class="pagination justify-content-end pages aas-pagination"
            >
                <ngb-pagination
                    [collectionSize]="totalElement"
                    [(page)]="page"
                    [maxSize]="3"
                    [rotate]="true"
                    [ellipses]="false"
                    [pageSize]="maxSize"
                    (pageChange)="loadPage($event)"
                    [boundaryLinks]="true"
                    aria-label="Default pagination"
                >
                    <ng-template ngbPaginationFirst>Đầu</ng-template>
                    <ng-template ngbPaginationLast>Cuối</ng-template>
                    <ng-template ngbPaginationPrevious>&laquo;</ng-template>
                    <ng-template ngbPaginationNext>&raquo;</ng-template>
                    <ng-template ngbPaginationNumber let-page>{{
                        page
                    }}</ng-template>
                </ngb-pagination>
            </div>
        </div>
        <div class="col-md-8">
            <div class="card shadow-none">
                <div class="card-body position-relative">
                    <div class="row">
                        <div class="col-md-auto align-self-end">
                            <label class="text-lg mb-0">Thông tin tài khoản</label>
                        </div>
                    </div>
                    <hr class="my-3" />
                    <div class="row">
                        <div class="col-md-6">
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Họ và tên</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.ten }}</span>
                                </div>
                            </div>

                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label  *ngIf="detailUser.loaiGtId === '0' || detailUser.loaiGtId === '1'" class="e-lb-field">Số CMND/CCCD</label>
                                    <label  *ngIf="!detailUser.loaiGtId || detailUser.loaiGtId === '2'" class="e-lb-field">Số hộ chiếu</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.cmnd }}</span>
                                </div>
                            </div>

                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Ngày sinh</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.ngaySinh | date: 'dd/MM/yyy' }}</span>
                                </div>
                            </div>

                            <div *ngIf="!detailUser.loaiGtId || detailUser.loaiGtId === '2'" class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Giới tính</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.gioiTinh || '' }}</span>
                                </div>
                            </div>

                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label  *ngIf="detailUser.loaiGtId === '0' || detailUser.loaiGtId === '1'" class="e-lb-field">Nơi ĐKHK TT</label>
                                    <label  *ngIf="!detailUser.loaiGtId || detailUser.loaiGtId === '2'" class="e-lb-field">Nơi sinh</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.diaChiThuongTru }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Ngày cấp</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.ngayCap | date: 'dd/MM/yyy' }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Nơi cấp</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.noiCap }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Số điện thoại</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.sdt }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Email</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.email }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Tài khoản</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.username }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Ngày đăng ký</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.created | date: 'dd/MM/yyy' }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Người phê duyệt</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{ detailUser.approverEmail }}</span>
                                </div>
                            </div>
                            <div class="e-block-field row">
                                <div class="col-md-4 col-xl-3">
                                    <label class="e-lb-field">Ngày phê duyệt</label>
                                </div>
                                <div class="col-md-8">
                                    <span class="e-txt-field">{{detailUser.approveDate | date: 'dd/MM/yyy' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div *ngIf="imageFirst || imageSecond" class="e-block-field row">
                                <div class="col-12 mb-2">
                                    <label class="e-lb-field mb-2">Ảnh chụp CMT</label>
                                </div>
                                <div *ngIf="imageFirst" class="col-md-6">
                                    <img class="img-cmnd" [src]="imageFirst" />
                                </div>
                                <div *ngIf="imageSecond" class="col-md-6">
                                    <img class="img-cmnd" [src]="imageSecond" />
                                </div>
                            </div>
                            <div *ngIf="url" class="e-block-field row">
                                <div class="col-12 mb-2">
                                    <label class="e-lb-field mb-2">Ảnh chụp khuôn mặt</label>
                                </div>
                                <div *ngIf="url" class="col-md-6">
                                    <img class="img-cmnd" [src]="url" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
